import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  t: PropTypes.func.isRequired,
};

const Benefits = ({ t }) => (
  <section className="LandingPage-section LandingPage-benefits">
    <div className="LandingPage-benefits-sectionContainer">
      <section className="LandingPage-benefits-section">
        <h3>{t("spages.referrals.landing.sections.Benefits.why.title")}</h3>
        <div>
          {t("spages.referrals.landing.sections.Benefits.why.description")}
        </div>
      </section>
      <section className="LandingPage-benefits-section">
        <h3>{t("spages.referrals.landing.sections.Benefits.control.title")}</h3>
        <div>
          {t("spages.referrals.landing.sections.Benefits.control.description")}
        </div>
      </section>
      <section className="LandingPage-benefits-section">
        <h3>{t("spages.referrals.landing.sections.Benefits.support.title")}</h3>
        <div>
          {t("spages.referrals.landing.sections.Benefits.support.description")}
        </div>
      </section>
    </div>
  </section>
);

Benefits.propTypes = propTypes;
export default Benefits;
